import {ProductInterface} from "../../interfaces/product/ProductInterface";
import {ProductPropertyInterface} from "../../interfaces/product/ProductPropertyInterface";
import BrandInfo from "./BrandInfo";

/**
 * Преобразует специальный формат описания Thorvik в HTML-таблицу
 * Формат: ------//------код|артикул|вес|шт|вес коробки#...------\\------
 */
function convertThorvikDescription(description: string): string {
    const lines = description.split("\n");
    const out: string[] = [];

    for (let str of lines) {
        // Обработка таблицы характеристик
        if (str.includes('------//------')) {
            str = str
                .replace(/------\/\/------/g, '')
                .replace(/------\\\\------/g, '')
                .replace(/<p>/g, '')
                .replace(/<\/p>/g, '');

            const items = str.split("#");

            let tableHtml = `<table class="table">
            <thead class="thead-dark">
            <tr>
                <th>Код</th>
                <th>Артикул</th>
                <th>Вес.</th>
                <th>Шт.</th>
                <th>Вес коробки.</th>
            </tr>
            </thead>
            <tbody>`;

            for (const item of items) {
                const trimmedItem = item.trim();
                if (!trimmedItem) continue;

                const columns = trimmedItem.split("|");

                if (columns.length === 1) {
                    // Заголовок раздела
                    tableHtml += `<tr><th colspan="5"><h4>${trimmedItem}</h4></th></tr>`;
                } else if (columns.length === 2) {
                    // Две колонки
                    tableHtml += `<tr><td colspan="3"><b>${columns[0]}</b></td><td colspan="2">${columns[1]}</td></tr>`;
                } else {
                    // Полная строка данных
                    tableHtml += `<tr><td>${columns.join('</td><td>')}</td></tr>`;
                }
            }

            tableHtml += '</tbody></table>';
            str = tableHtml;
        }

        // Обработка блока связанного товара
        if (str.includes('<<R<<')) {
            str = str.replace(/<<R<</g, '').replace(/>>R>>/g, '');
            const [desc, articul] = str.split("|");
            str = `<div class="remcomplet">
                <table>
                    <tr>
                        <td colspan="2"><div class="description"><a href="https://thorvik.ru/catalog/50003/">${desc}</a></div></td>
                    </tr>
                    <tr class="link">
                        <td><a href="/catalog/50003/">Арт.: ${articul}</a></td>
                        <td style="text-align:right;"><a href="https://thorvik.ru/catalog/50003/">>></a></td>
                    </tr>
                </table>
            </div>`;
        }

        out.push(str);
    }

    return out.join("\n");
}

/**
 * Преобразует HTML-описание продукта:
 * - Удаляет inline-стили
 * - Удаляет атрибуты width/height
 * - Добавляет класс table к таблицам
 * - Преобразует специальный формат Thorvik (при наличии)
 * - Заменяет относительные пути изображений на абсолютные
 */
function convertDescription(description: string | undefined): string {
    if (!description) return '';

    let result = description;

    // Удаляем inline-стили
    result = result.replace(/style=["'][^"']*["']/gi, '');

    // Удаляем атрибуты width и height
    result = result.replace(/(width|height)=["']\d+["']/gi, '');

    // Добавляем класс table к таблицам
    result = result.replace(/<table/g, '<table class="table"');

    // Заменяем относительные пути изображений
    result = result.replace(/src="\/public\/upload\//g, 'src="https://www.pride.ru/public/upload/');

    // Преобразуем специальный формат Thorvik (только при наличии маркера)
    if (result.includes('------//------')) {
        result = convertThorvikDescription(result);
    }

    return result;
}

export default function Description({product}: {product:ProductInterface}) {
    const descriptionHtml = convertDescription(product.additional_params?.description);
    const videos = [...(product.additional_params?.images?.video || [])]
        .sort((a, b) => a.localeCompare(b, undefined, {numeric: true}));

    return (<div
        className="flex-column flex-lg-row gap-4 fade justify-content-between prod-pane  active show"
       >
        <div className="d-flex flex-column prod-pane__left">
            <div className="prod-pane__text">
                <p className="fw-bold text-uppercase">Описание</p>
                <div dangerouslySetInnerHTML={{__html: descriptionHtml}}></div>
                {videos.map(video => (
                    <div className="text-center my-3" key={video}>
                        <video controls loop muted playsInline preload="metadata"
                               className="mw-100" style={{maxHeight: '480px'}}>
                            <source src={'https://www.pride.ru' + video} type="video/mp4"/>
                            Ваш браузер не поддерживает воспроизведение видео.
                        </video>
                    </div>
                ))}
            </div>
        </div>
        <BrandInfo product={product} />
    </div>)
}